/* THALIA — Hediye tester seçici (İkipixel) · v2
 *
 * Sepet çekmecesi ve sepet sayfasında "Hediye tester'larını seç" bandı + pop-up.
 *   · Tester ve hediye kartı dışında ürün varsa  → 2 Thalia bakım tester'ı
 *   · Thalia Fragrances ürünü varsa               → + 2 parfüm tester'ı
 *   · Sepetteki parfümün (aynı kokunun) tester'ı gösterilmez; sepette varsa çıkarılır
 *   · Hak düşerse (ürün silinirse) fazla tester'lar sepetten çıkarılır
 * Ücretsiz olma işi Shopify'daki "X Al Y Kazan" indirimlerinde. Ödeme sayfasına dokunulmaz.
 * Sepet durumu: sections/tester-secici.liquid · Tester listeleri: sections/tester-secici-liste.liquid
 */
(function () {
  'use strict';

  var C = Object.assign({
    quota: { bakim: 2, parfum: 2 },
    collections: { bakim: 'tester-bakim', parfum: 'tester-parfum' },
    section: 'tester-secici',
    listSection: 'tester-secici-liste',
    ayniKokuJelly: true,
    root: '/'
  }, (typeof window !== 'undefined' && window.TesterSeciciConfig) || {});
  var ROOT = String(C.root || '/').replace(/\/?$/, '/');
  var KINDS = ['bakim', 'parfum'];
  var LABEL = { bakim: 'Thalia bakım tester\'ları', parfum: 'Parfüm tester\'ları' };

  /* ------------------------------------------------------------ saf mantık */
  function kindOf(it) {
    if (it.kind) return it.kind;
    return /^tester-eau-de-parfum-/.test(it.handle) ? 'parfum' : 'bakim';
  }
  function kaynakOf(it) {
    return it.kaynak || String(it.handle || '').replace(/^tester-/, '').replace(/-\d+(?:-\d+)?-ml$/, '');
  }
  // Koku adı: eau-de-parfum-x / jelly-perfume-balm-x → x
  function scentOf(handle) {
    return String(handle || '').replace(/^eau-de-parfum-/, '').replace(/^jelly-perfume-balm-/, '');
  }
  function blockedSet(items) {
    var s = {};
    items.forEach(function (i) {
      if (!i.frag || !(i.qty > 0)) return;
      s[i.handle] = 1;
      if (C.ayniKokuJelly) s['scent:' + scentOf(i.handle)] = 1;
    });
    return s;
  }
  function isBlocked(blocked, kaynak) {
    return !!(blocked[kaynak] || (C.ayniKokuJelly && blocked['scent:' + scentOf(kaynak)]));
  }
  // items: tester-secici bölümünden gelen satırlar (Shopify sırası: en yeni eklenen başta)
  function analyze(items) {
    items = items || [];
    var hasElig = items.some(function (i) { return i.elig && i.qty > 0; });
    var hasFrag = items.some(function (i) { return i.frag && i.qty > 0; });
    var quota = { bakim: hasElig ? C.quota.bakim : 0, parfum: hasFrag ? C.quota.parfum : 0 };
    var blocked = blockedSet(items);
    var used = { bakim: 0, parfum: 0 };
    var updates = {};
    var inCart = {};
    items.slice().reverse().forEach(function (t) {          // en eski önce kalır
      if (!t.tester || !(t.qty > 0)) return;
      var k = kindOf(t);
      if (k === 'parfum' && isBlocked(blocked, kaynakOf(t))) { updates[t.key] = 0; return; }
      if (inCart[t.handle]) { updates[t.key] = 0; return; }  // aynı tester ikinci satır
      if (used[k] >= quota[k]) { updates[t.key] = 0; return; }
      if (t.qty > 1) updates[t.key] = 1;                   // hediye tekli
      used[k] += 1;
      inCart[t.handle] = { key: t.key, kind: k };
    });
    return { quota: quota, used: used, updates: updates, inCart: inCart, blocked: blocked,
             total: quota.bakim + quota.parfum, hasElig: hasElig, hasFrag: hasFrag };
  }
  // Pop-up kaydı: seçili handle listesi → eklenecek / çıkarılacak satırlar
  function diff(state, selected, testersByHandle) {
    var updates = {}, add = [];
    Object.keys(state.inCart).forEach(function (h) { if (!selected[h]) updates[state.inCart[h].key] = 0; });
    Object.keys(selected).forEach(function (h) {
      if (!state.inCart[h] && testersByHandle[h]) add.push({ id: testersByHandle[h].id, quantity: 1 });
    });
    return { updates: updates, add: add };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { analyze: analyze, diff: diff, kaynakOf: kaynakOf, scentOf: scentOf, _C: C };
  }
  if (typeof document === 'undefined' || window.__testerSecici) return;
  window.__testerSecici = true;

  /* ------------------------------------------------------------ ağ */
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function getState() {
    return fetchRetry(ROOT + '?sections=' + encodeURIComponent(C.section), 2)
      .then(function (j) {
        var html = j && j[C.section];
        var m = html && html.match(/<script[^>]*data-tester-durum[^>]*>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('tester-secici bölümü okunamadı');
        return JSON.parse(m[1]).items || [];
      });
  }
  var TESTERS = null, TPROM = null;
  function fetchRetry(url, tries) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (r.status === 429 && tries > 0) {
        return new Promise(function (res) { setTimeout(res, 900); }).then(function () { return fetchRetry(url, tries - 1); });
      }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function getTesters() {
    if (TESTERS) return Promise.resolve(TESTERS);
    if (TPROM) return TPROM;
    var KEY = 'ts-testers-v2';
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 10 * 60 * 1000) { TESTERS = c.d; return Promise.resolve(TESTERS); }
    } catch (e) { /* yok say */ }
    TPROM = fetchRetry(ROOT + '?sections=' + encodeURIComponent(C.listSection), 2)
      .then(function (j) {
        var html = j && j[C.listSection];
        var m = html && html.match(/<script[^>]*data-tester-liste[^>]*>([\s\S]*?)<\/script>/);
        var d = m ? JSON.parse(m[1]) : { bakim: [], parfum: [] };
        TESTERS = {};
        KINDS.forEach(function (k) {
          TESTERS[k] = (d[k] || []).map(function (t) {
            var img = t.img || '';
            if (img.indexOf('//') === 0) img = 'https:' + img;
            return { kind: k, handle: t.handle, id: t.id, title: t.title, img: img, kaynak: t.kaynak || '' };
          });
        });
        if (TESTERS.bakim.length || TESTERS.parfum.length) {
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: TESTERS })); } catch (e) { /* yok say */ }
        }
        return TESTERS;
      })
      .catch(function (e) { console.warn('[tester-secici] liste', e); return { bakim: [], parfum: [] }; })
      .then(function (r) { TPROM = null; return r; });
    return TPROM;
  }
  function bundleSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    return sections.filter(function (s, i, a) { return s && a.indexOf(s) === i; });
  }
  var SELF = false;
  function applyCart(ch) {
    var sections = bundleSections(), last = null, p = Promise.resolve();
    if (ch.updates && Object.keys(ch.updates).length) {
      p = p.then(function () {
        return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ updates: ch.updates, sections: sections }) })
          .then(function (r) { return r.json(); }).then(function (j) { last = j; });
      });
    }
    if (ch.add && ch.add.length) {
      p = p.then(function () {
        return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: ch.add, sections: sections }) })
          .then(function (r) { return r.json(); }).then(function (j) {
            if (j && j.status) throw new Error(j.description || j.message || 'Sepete eklenemedi');
            last = j;
          });
      });
    }
    return p.then(function () { return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.sections = last && last.sections;
        SELF = true;
        try {
          if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          else document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        } finally { SELF = false; }
        return cart;
      });
  }

  /* ------------------------------------------------------------ durum */
  var STATE = null, BUSY = false, AGAIN = null;
  function sync(opts) {
    if (BUSY) { AGAIN = Object.assign(AGAIN || {}, opts || {}); return Promise.resolve(); }
    BUSY = true;
    return getState()
      .then(function (items) {
        var a = analyze(items);
        if (Object.keys(a.updates).length) {
          return applyCart({ updates: a.updates }).then(getState).then(analyze);
        }
        return a;
      })
      .then(function (a) {
        var prev = STATE; STATE = a; renderBanners();
        if (a.total > 0) getTesters().then(renderBanners);
        if (opts && opts.maybeOpen) maybeOpen();
        else if (prev && a.total > prev.total) maybeOpen();
      })
      .catch(function (e) { console.warn('[tester-secici]', e); })
      .then(function () { BUSY = false; if (AGAIN) { var o = AGAIN; AGAIN = null; sync(o); } });
  }
  var t0 = null;
  function syncSoon(opts) { clearTimeout(t0); t0 = setTimeout(function () { sync(opts); }, 350); }

  function available(kind) {
    if (!TESTERS || !STATE) return [];
    return (TESTERS[kind] || []).filter(function (t) {
      return !(kind === 'parfum' && isBlocked(STATE.blocked, kaynakOf(t)));
    });
  }
  function remaining() {
    if (!STATE) return 0;
    return KINDS.reduce(function (n, k) {
      var cap = Math.min(STATE.quota[k], STATE.used[k] + available(k).filter(function (t) { return !STATE.inCart[t.handle]; }).length);
      return n + Math.max(0, cap - STATE.used[k]);
    }, 0);
  }

  /* ------------------------------------------------------------ bant */
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  function bannerHTML() {
    var used = STATE.used.bakim + STATE.used.parfum, left = remaining();
    var sub = KINDS.filter(function (k) { return STATE.quota[k] > 0; })
      .map(function (k) { return (k === 'bakim' ? 'Bakım ' : 'Parfüm ') + STATE.used[k] + '/' + STATE.quota[k]; }).join(' · ');
    return GIFT + '<span class="ts-banner__txt"><b>' + (left > 0 ? 'Hediye tester\'larını seç' : 'Hediye tester\'ların sepette') + '</b><span>' + sub + ' · ücretsiz</span></span>' +
      '<span class="ts-banner__cta">' + (left > 0 ? 'Seç' : (used ? 'Değiştir' : 'Gör')) + '</span>';
  }
  var TARGETS = [
    '#CartDrawer .drawer__footer-buttons',
    'main-cart .cart__footer--buttons',
    '.cart__footer .cart__footer--buttons'
  ];
  function renderBanners() {
    var show = STATE && STATE.total > 0 && TESTERS && KINDS.some(function (k) { return STATE.quota[k] > 0 && available(k).length; });
    TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var wrap = el.previousElementSibling && el.previousElementSibling.classList.contains('ts-banner-wrap') ? el.previousElementSibling : null;
        if (!show) { if (wrap) wrap.remove(); return; }
        if (!wrap) {
          wrap = document.createElement('div'); wrap.className = 'ts-banner-wrap';
          wrap.innerHTML = '<button type="button" class="ts-banner" data-ts-open></button>';
          el.parentNode.insertBefore(wrap, el);
        }
        var b = wrap.querySelector('.ts-banner'), h = bannerHTML();
        if (b.getAttribute('data-sig') !== h) { b.innerHTML = h; b.setAttribute('data-sig', h); }
      });
    });
  }

  /* ------------------------------------------------------------ pop-up */
  var MODAL = null, SEL = {}, LASTFOCUS = null;
  function sig() { return STATE ? STATE.quota.bakim + '-' + STATE.quota.parfum : ''; }
  function dismissed() { try { return sessionStorage.getItem('ts-dismiss') === sig(); } catch (e) { return false; } }
  function setDismissed() { try { sessionStorage.setItem('ts-dismiss', sig()); } catch (e) { /* yok say */ } }
  function maybeOpen() {
    if (window.Shopify && Shopify.designMode) return;
    if (!STATE || STATE.total === 0 || dismissed()) return;
    getTesters().then(function () { if (remaining() > 0) setTimeout(open, 450); });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nameParts(title) {
    var m = String(title).match(/^(.*?)\s+(?:Eau de Parfum\s+)?Tester\s+(.+)$/i);
    return m ? [m[1], m[2] + (/Eau de Parfum/i.test(title) ? ' · EDP' : '')] : [title, ''];
  }
  function countSel(kind) {
    return Object.keys(SEL).filter(function (h) { return SEL[h] === kind; }).length;
  }
  function build() {
    MODAL = document.createElement('div');
    MODAL.className = 'ts-modal'; MODAL.hidden = true;
    MODAL.innerHTML =
      '<div class="ts-modal__overlay" data-ts-close></div>' +
      '<div class="ts-modal__box" role="dialog" aria-modal="true" aria-labelledby="ts-title">' +
        '<button type="button" class="ts-modal__close" data-ts-close aria-label="Kapat">×</button>' +
        '<div class="ts-modal__head"><h2 id="ts-title">Hediye tester\'larını seç</h2><p>Seçtiklerin siparişine ücretsiz eklenir.</p></div>' +
        '<div class="ts-modal__body"></div>' +
        '<p class="ts-err" hidden></p>' +
        '<div class="ts-modal__foot"><span class="ts-modal__sum"></span><div class="ts-modal__actions">' +
          '<button type="button" class="ts-btn" data-ts-close>Şimdi değil</button>' +
          '<button type="button" class="ts-btn ts-btn--primary" data-ts-save>Sepete ekle</button>' +
        '</div></div>' +
      '</div>';
    document.body.appendChild(MODAL);
    MODAL.addEventListener('click', function (e) {
      if (e.target.closest('[data-ts-close]')) { e.preventDefault(); close(true); return; }
      if (e.target.closest('[data-ts-save]')) { e.preventDefault(); save(); return; }
      var card = e.target.closest('.ts-card');
      if (card && !card.disabled) {
        var h = card.getAttribute('data-h'), k = card.getAttribute('data-k');
        if (SEL[h]) delete SEL[h]; else if (countSel(k) < STATE.quota[k]) SEL[h] = k;
        paint();
      }
    });
    MODAL.addEventListener('input', function (e) {
      if (!e.target.matches('.ts-search')) return;
      var q = e.target.value.toLocaleLowerCase('tr');
      MODAL.querySelectorAll('.ts-grp[data-k="parfum"] .ts-card').forEach(function (c) {
        c.hidden = q && c.getAttribute('data-n').indexOf(q) === -1;
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && MODAL && !MODAL.hidden) close(true); });
  }
  function body() {
    var html = '';
    KINDS.forEach(function (k) {
      if (!STATE.quota[k]) return;
      var list = available(k);
      html += '<section class="ts-grp" data-k="' + k + '"><div class="ts-grp__head"><h3>' + LABEL[k] + ' · ' + STATE.quota[k] + ' seçebilirsin</h3>' +
        '<span class="ts-grp__count" data-count="' + k + '"></span></div>';
      if (k === 'parfum' && list.length > 12) html += '<input type="search" class="ts-search" placeholder="Parfüm ara" aria-label="Parfüm ara">';
      if (!list.length) html += '<p class="ts-empty">Şu an seçilebilecek tester yok.</p>';
      html += '<div class="ts-grid">' + list.map(function (t) {
        var n = nameParts(t.title);
        return '<button type="button" class="ts-card" data-h="' + esc(t.handle) + '" data-k="' + k + '" data-n="' + esc(n[0].toLocaleLowerCase('tr')) + '" aria-pressed="false">' +
          (t.img ? '<img src="' + esc(t.img) + '" alt="" loading="lazy" width="300" height="300">' : '') +
          '<span class="ts-card__name">' + esc(n[0]) + '</span><span class="ts-card__size">' + esc(n[1]) + '</span></button>';
      }).join('') + '</div></section>';
    });
    MODAL.querySelector('.ts-modal__body').innerHTML = html;
  }
  function paint() {
    KINDS.forEach(function (k) {
      if (!STATE.quota[k]) return;
      var full = countSel(k) >= STATE.quota[k];
      MODAL.querySelectorAll('.ts-card[data-k="' + k + '"]').forEach(function (c) {
        var on = !!SEL[c.getAttribute('data-h')];
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.disabled = !on && full;
      });
      var cnt = MODAL.querySelector('[data-count="' + k + '"]');
      if (cnt) cnt.textContent = countSel(k) + '/' + STATE.quota[k];
    });
    var changed = Object.keys(SEL).length !== Object.keys(STATE.inCart).length ||
      Object.keys(SEL).some(function (h) { return !STATE.inCart[h]; });
    var btn = MODAL.querySelector('[data-ts-save]');
    btn.textContent = Object.keys(STATE.inCart).length ? 'Seçimi kaydet' : 'Sepete ekle';
    btn.disabled = !changed;
    MODAL.querySelector('.ts-modal__sum').textContent = KINDS.filter(function (k) { return STATE.quota[k]; })
      .map(function (k) { return (k === 'bakim' ? 'Bakım ' : 'Parfüm ') + countSel(k) + '/' + STATE.quota[k]; }).join(' · ');
  }
  function open() {
    if (!STATE || STATE.total === 0) return;
    getTesters().then(function () {
      if (!MODAL) build();
      SEL = {};
      Object.keys(STATE.inCart).forEach(function (h) { SEL[h] = STATE.inCart[h].kind; });
      body(); paint();
      MODAL.querySelector('.ts-err').hidden = true;
      LASTFOCUS = document.activeElement;
      MODAL.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = MODAL.querySelector('.ts-card:not([disabled])') || MODAL.querySelector('.ts-modal__close');
      if (first) first.focus({ preventScroll: true });
    });
  }
  function close(dismiss) {
    if (!MODAL) return;
    MODAL.hidden = true;
    document.documentElement.style.overflow = '';
    if (dismiss) setDismissed();
    if (LASTFOCUS && LASTFOCUS.focus) try { LASTFOCUS.focus({ preventScroll: true }); } catch (e) { /* yok say */ }
  }
  function save() {
    var btn = MODAL.querySelector('[data-ts-save]'), err = MODAL.querySelector('.ts-err');
    var byH = {};
    KINDS.forEach(function (k) { ((TESTERS && TESTERS[k]) || []).forEach(function (t) { byH[t.handle] = t; }); });
    var ch = diff(STATE, SEL, byH);
    btn.setAttribute('aria-busy', 'true'); err.hidden = true;
    applyCart(ch)
      .then(function () { setDismissed(); close(false); return sync(); })
      .catch(function (e) { err.textContent = (e && e.message) || 'Bir sorun oluştu, tekrar dene.'; err.hidden = false; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ------------------------------------------------------------ bağlantılar */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ts-open]')) { e.preventDefault(); open(); }
  });
  function hookTheme() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () { if (!SELF) syncSoon(); });
    }
    document.addEventListener('cart:refresh', function () { syncSoon(); });
    // Çekmece açılınca: durum tazele + gerekiyorsa pop-up
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { if (drawer.hasAttribute('open')) syncSoon({ maybeOpen: true }); })
        .observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
    // Bölümler yeniden çizildiğinde bandı geri koy
    if (window.MutationObserver) {
      var raf = 0;
      new MutationObserver(function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; if (STATE) renderBanners(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  function start() {
    hookTheme();
    var onCartPage = !!document.querySelector('main-cart') || /\/cart\/?$/.test(location.pathname);
    sync({ maybeOpen: onCartPage });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.TesterSecici = { open: open, sync: sync };
})();
